import bytes from 'bytes'
import React from 'react'
import { MdFileDownload } from 'react-icons/md'

import { CircularProgress } from '../../shared/NarusMaterial'

const ImagePreviewer = ({ data, handleClick, handleOpenInNewTab, url, meta }) => (
  <button
    className='image-preview-wrapper'
    onClick={handleClick}
  >
    {data
      ? (
        <img
          src={data}
          alt=''
        />
      )
      : <CircularProgress color='purple' />
    }
    <button
      className='nh-download-icon download-icon'
      onClick={(e) => {
        e.stopPropagation()
        handleOpenInNewTab(url)
      }}
      title={`Download ${meta?.filename} (${bytes(meta?.size)})`}
    >
      <MdFileDownload size='1.2rem' />
    </button>
  </button>
)

export default ImagePreviewer
